import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateChild, Router } from "@angular/router";
import { Store } from "@ngxs/store";
// State
import { ClearIntegrationOrganization, ClearIntegrationOrganizationMenu, SetIntegration, SetIntegrationMenu } from "../state/actions/generic-integation.actions";
import { GenericIntegrationState } from "../state/generic-integation.state";
import {
	SetAppScopePropertyTypes,
	SetAcuityPropertyTypes,
	SetAppScopeLoanTypes,
	SetAcuityLoanTypes,
	SetAcuityLoanReasons,
	SetAppScopeLoanReasons,
	SetAcuityOccupancyTypes,
	SetAppScopeOccupancyTypes,
	SetAppScopeDocumentTypes,
	SetAcuityDocumentTypes,
	SetGenericIntegrations,
	SetClassValuationDocumentTypes,
	SetCmpAcuityPropertyTypes,
	SetCmpAcuityLoanTypes,
	SetCmpAcuityLoanReasons,
	SetCmpAcuityDocumentTypes,
	SetCmpAcuityOccupancyTypes,
	SetTrackingSystems,
	SetActionOptions,
	SetCMPOnHoldReasons,
	SetReceiveFromClientOptions,
	SetHandleMode
} from "../../state/actions/global-configuration.actions";
// Service
import { BroadcastService, CONTENT_LOADER_EVENT } from "@cv-invision/core";
// Model
import { IntegrationOrganizationItemModel, IntegrationsModel } from "../models/integrations.model";

@Injectable()
export class GenericIntegrationLoaderGuard implements CanActivateChild {

	constructor(
		private router: Router,
		private store: Store,
		private broadcast: BroadcastService
	) { }

	/**
	 * CanActivateChidl method
	 *
	 * @param route
	 * @returns Promise<boolean>
	 */
	canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean> {
		const integrationId = route.params['integrationId'];

		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async resolve => {
			try {
				if (integrationId != '') {
					const currentIntegration: IntegrationsModel = this.store.selectSnapshot(GenericIntegrationState.getIntegration);
					const currentOrg: IntegrationOrganizationItemModel = this.store.selectSnapshot(GenericIntegrationState.getIntegrationOrganization);
					await this.store.dispatch(new SetTrackingSystems()).toPromise();
					await this.store.dispatch(new SetHandleMode()).toPromise();

					if (!currentIntegration || currentIntegration.integrationId !== integrationId) {
						const newCurrentIntegration = this.store.selectSnapshot(GenericIntegrationState.getIntegrations)
							.find(integration => integration.integrationId === integrationId);



						await this.store.dispatch(new SetIntegration(newCurrentIntegration)).toPromise();
						await this.store.dispatch(new SetIntegrationMenu(integrationId, true)).toPromise();

						await this.store.dispatch(new SetAppScopePropertyTypes()).toPromise();
						await this.store.dispatch(new SetAcuityPropertyTypes()).toPromise();
						await this.store.dispatch(new SetCmpAcuityPropertyTypes()).toPromise();

						await this.store.dispatch(new SetAppScopeLoanTypes()).toPromise();
						await this.store.dispatch(new SetAcuityLoanTypes()).toPromise();
						await this.store.dispatch(new SetCmpAcuityLoanTypes()).toPromise();

						await this.store.dispatch(new SetAcuityLoanReasons()).toPromise();
						await this.store.dispatch(new SetAppScopeLoanReasons()).toPromise();
						await this.store.dispatch(new SetCmpAcuityLoanReasons()).toPromise();

						await this.store.dispatch(new SetAcuityOccupancyTypes()).toPromise();
						await this.store.dispatch(new SetAppScopeOccupancyTypes()).toPromise();
						await this.store.dispatch(new SetCmpAcuityOccupancyTypes()).toPromise();

						await this.store.dispatch(new SetAppScopeDocumentTypes()).toPromise();
						await this.store.dispatch(new SetAcuityDocumentTypes()).toPromise();
						await this.store.dispatch(new SetCmpAcuityDocumentTypes()).toPromise();
						await this.store.dispatch(new SetClassValuationDocumentTypes()).toPromise();
						await this.store.dispatch(new SetActionOptions()).toPromise();
						await this.store.dispatch(new SetCMPOnHoldReasons()).toPromise();
						await this.store.dispatch(new SetReceiveFromClientOptions()).toPromise();
					}

					if (!('organizationIntegrationId' in route.params) && currentOrg !== null) {
						await this.store.dispatch(new ClearIntegrationOrganization()).toPromise();
						await this.store.dispatch(new ClearIntegrationOrganizationMenu()).toPromise();
					}

					this.broadcast.broadcast({
						name: CONTENT_LOADER_EVENT,
						event: {
							isLoader: false
						}
					});
					resolve(true);
				} else {
					return resolve(this.rejectToMainModule());
				}
			} catch (error) {
				return resolve(this.rejectToMainModule());
			}
		});
	}

	/**
	 * Kick the user out of Quality Process
	 */
	private rejectToMainModule(): boolean {
		this.broadcast.broadcast({
			name: CONTENT_LOADER_EVENT,
			event: {
				isLoader: false
			}
		});

		this.router.navigate(['/global-configuration/generic-integrations']);

		return false;
	}
}
